import React from "react"
import { Field } from "redux-form/immutable"
import PageTemplate from "QuorumGrassroots/framework/components/Foundations/PageTemplate"
import { StyledButton } from "QuorumGrassroots/styled-components/components/StyledButton"
import InputFieldComponent from "app/static/frontend/forms/components/InputField"
import { getCustomValidator } from "QuorumGrassroots/widgets/ReusableComponents/UserInfoFormSection/customValidators"

const { FormInputType } = DjangIO.app.grassroots.types

export const ResetPasswordPage = ({ t, isCollaboratorInitialReset, ...props }) => {
    const pageTitle = isCollaboratorInitialReset
        ? "Welcome to Quorum Collaborator"
        : t("registration.password.reset.label")

    return (
        <PageTemplate className="reset-password-page" title={pageTitle}>
            {isCollaboratorInitialReset && (
                <div>
                    <p>Quorum Collaborator provides a streamlined way for you to engage with legislation.</p>
                    <p>
                        As a Collaborator, you have limited access to view select bill details and share your insights
                        by adding comments.
                    </p>
                    <br />
                    <p>Please set your password:</p>
                </div>
            )}
            <form onSubmit={props.handleSubmit}>
                <Field
                    name="password"
                    dataCy="password"
                    label={t("registration.password.label")}
                    component={InputFieldComponent}
                    placeholder={t("registration.password.label")}
                    displayErrorWithoutTouch={false}
                    validate={getCustomValidator(FormInputType.text.value, t("registration.password.label"), true)}
                    type="password"
                />
                <Field
                    name="passwordConfirm"
                    dataCy="passwordConfirm"
                    label={t("registration.password.reenter_label")}
                    component={InputFieldComponent}
                    placeholder={t("registration.password.reenter_label")}
                    displayErrorWithoutTouch={false}
                    validate={getCustomValidator(
                        FormInputType.text.value,
                        t("registration.password.reenter_label"),
                        true,
                    )}
                    type="password"
                />
                <StyledButton onClick={props.handleSubmit} disabled={props.invalid || props.submitting} type="submit">
                    {props.submitting ? t("form.submitting") : t("form.submit_form")}
                </StyledButton>
            </form>
        </PageTemplate>
    )
}

export default ResetPasswordPage
